import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";
import { Observable, of } from "rxjs";
import { map, tap, first, catchError } from "rxjs/operators";
import { localStorageKey } from "@core/constants";

@Injectable()
export class AuthenticationGuard {
  constructor(private router: Router, public authService: AuthService) {}

  canActivate(): Observable<boolean> {
   
    const hasLocalStorageData = () => {
      try {
        const data = localStorage.getItem(localStorageKey);
        return data && JSON.parse(data)?.user && JSON.parse(data)?.tokenClaims;
      } catch {
        return false;
      }
    };

    const returnObservable = this.authService.isAuthenticated$.pipe(
      first(),
      map((isAuthenticated) => {
      
        if (!isAuthenticated && hasLocalStorageData()) {
          return true;
        }
        return isAuthenticated;
      }),
      tap((isAuthenticated) => {
        if (!isAuthenticated) {
          localStorage.clear();
          this.router.navigate(["/login"]);
        }
      }),
      catchError(() => {
     
        if (hasLocalStorageData()) {
          return of(true);
        }
        return of(false);
      })
    );
    return returnObservable;
  }
}
